import { format } from 'date-fns';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import OpacityAnimation from '../../../../../components/OpacityAnimation';
import MyModal from '../../../../../components/Modal';
import { MappedActivityRating } from '../../types';
import { Card } from './styles';
import { ModalContainer } from '../../styles';

interface ListInterface {
  filteredList: MappedActivityRating[];
}

export default function List({ filteredList }: ListInterface) {
  const [commentModalShow, setCommentModalShow] = useState(false);
  const [selectedComment, setSelectedComment] = useState('');

  const handleOpenCommentModal = (comment: string) => {
    setSelectedComment(comment);
    setCommentModalShow(true);
  };

  const renderStars = (rating: number) => {
    return `${'⭐'.repeat(rating)} (${rating}/5)`;
  };

  return (
    <>
      <Container>
        <Row xs={1} md={2} lg={2}>
          {filteredList?.map((rating, index) => (
            <Col key={`${rating.activityId}-${rating.partnerId}-${index}`}>
              <OpacityAnimation delay={0.1}>
                <Card>
                  <div className="info">
                    <div className="card-title">
                      <strong>{rating.activity}</strong>
                      {rating.comment && (
                        <button
                          type="button"
                          onClick={() => handleOpenCommentModal(rating.comment)}
                        >
                          Ver comentário
                        </button>
                      )}
                    </div>
                    <span>
                      <strong>Data Avaliação:</strong>{' '}
                      {format(new Date(rating.ratedAt), 'dd/MM/yyyy \'às\' HH\'h\'mm\'m\'')}
                    </span>
                    <div className="rating-stars">
                      <div className="rating-item">
                        <span>Professor:</span>
                        {renderStars(rating.teacherRate)}
                      </div>
                      <div className="rating-item">
                        <span>Conteúdo:</span>
                        {renderStars(rating.contentRate)}
                      </div>
                      <div className="rating-item">
                        <span>Duração:</span>
                        {rating.durationRate || 'Não informado'}
                      </div>
                    </div>
                  </div>
                </Card>
              </OpacityAnimation>
            </Col>
          ))}
        </Row>
      </Container>

      <MyModal
        show={commentModalShow}
        title="Comentário Adicional"
        closeButtonLabel="Fechar"
        onClose={() => setCommentModalShow(false)}
        type="info"
        modalBody={(
          <ModalContainer>
            <p>{selectedComment}</p>
          </ModalContainer>
        )}
      />
    </>
  );
}
